import { Transform3D } from "../../types";

export type BackgroundsProps<T> = {
  props?: T;
  children?: React.ReactNode;
};

export enum NvsBackgroundTypes {
  ColorBackground = "Color",
  StaticBackground = "Static",
  Background360 = "360",
}

export type NvsBackgroundsKey = keyof typeof NvsBackgroundTypes;
export type NvsBackgroundsValue = typeof NvsBackgroundTypes[NvsBackgroundsKey];

export type NvsBackgroundProps = {
  backgroundType: NvsBackgroundsValue;
  hexColor?: string;
};

export type AssetBackgroundProps = {
  asset: {
    url: string;
  };
};

export type AssetBackground360Props = {
  radius: number;
} & AssetBackgroundProps;

export type ColorBackgroundProps = {
  hexColor: string;
};

export type EnvironmentSphereProps = {
  mapUrl: string;
  radius: number;
} & Transform3D;
